import React, { Component } from 'react'
import Brand from 'components/Brand/Brand'
import { withTranslation } from 'react-i18next'
import _PageHeader_Logo_Text from 'containers/Page/Header/_components/Logo/_styles/_PageHeader_Logo_Text'
import _PageHeader_Logo_SportType from 'containers/Page/Header/_components/Logo/_styles/_PageHeader_Logo_SportType'
import { urlRootPath } from 'helpers/urlPath'
import { DEFAULT_SPORT_PAGE_URL_PART, SPORT_URL_PART } from 'pages/Sport/_constants/SPORT_URLS'
import _PageHeader_Logo_Wrapper from 'containers/Page/Header/_components/Logo/_styles/_PageHeader_Logo_Wrapper'
import sportContextConnector from 'pages/Sport/_context/sportContextConnector'

@withTranslation()
@sportContextConnector(['sport_key', 'title'])
export default class _PageHeader_Logo extends Component {
  render () {
    const {
      props: {
        sport_key,
        title,
      }
    } = this
    return (
      <_PageHeader_Logo_Wrapper>
        <_PageHeader_Logo_Text href={'/'}>
          <Brand />
        </_PageHeader_Logo_Text>
        {title &&
        <_PageHeader_Logo_SportType
          to={urlRootPath(
            SPORT_URL_PART,
            sport_key,
            DEFAULT_SPORT_PAGE_URL_PART
          )}
        >
          {title}
        </_PageHeader_Logo_SportType>
        }
      </_PageHeader_Logo_Wrapper>
    )
  }
}
